export default __webpack_public_path__ + "static/media/logo_tel_access_white.153c7209.png";